import React, { useContext } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import { DynamicColumns, SingleLine } from '../common/coupon/index'
import SplitLine from '../common/split-line'
import { IMachineConfig, IState, IWorth } from '../../types'
import context from '../../context'

interface IProps extends IState {
  lang: string
  fold: boolean
  handle: () => void
}

const CommonHeader = (props: Partial<IProps>) => {
  const { lang } = props
  return (
    <div className={styles.headlineOutside}>
      <div className={classnames(styles.start, styles[lang])} />
      <div className={classnames(styles.tips, styles[lang])} />
      {/* <div className={styles.mask} /> */}
    </div>
  )
}

const CommonCoupon = (props: { your: IWorth; friend: IWorth }) => {
  const { your, friend } = props
  return (
    <div className={styles.benefits}>
      <div className={styles.group}>
        <DynamicColumns type="aHalf" columns={[your]} flow="before" />
        <SplitLine width={3} />
        <DynamicColumns type="aHalf" columns={[friend]} flow="before" />
      </div>
    </div>
  )
}

const Seller = (props: IMachineConfig & Partial<IProps>) => {
  const {
    /* 注册 */
    currencySign,
    registryCouponNameYour1,
    registryCouponValYour1,
    /* 售卖 */
    sellCouponNameYour,
    sellCouponValYour,
    /* 出价 */
    bidCouponNameFriend,
    bidCouponValFriend,
    lang,
  } = props

  return (
    <>
      <CommonHeader lang={lang} />
      <section className={classnames(styles.sharingOutside, styles.seller)}>
        <div className={styles.benefits}>
          <SingleLine
            flow="before"
            columns={[
              {
                isDiscount: false,
                currencySign,
                sum: registryCouponValYour1,
                explain: registryCouponNameYour1,
              },
            ]}
          />
        </div>
        <CommonCoupon
          your={{
            type: 'percent',
            currencySign,
            sum: sellCouponValYour,
            explain: sellCouponNameYour,
          }}
          friend={{
            isDiscount: false,
            currencySign,
            sum: bidCouponValFriend,
            explain: bidCouponNameFriend,
          }}
        />
      </section>
    </>
  )
}

const Transaction = (props: IMachineConfig & Partial<IProps>) => {
  const {
    currencySign,
    /* 注册 */
    registryCouponNameYour1,
    registryCouponValYour1,
    registryCouponNameYour2,
    registryCouponValYour2,
    /* 支付 */
    payCouponNameFriend,
    payCouponValFriend,
    payCouponNameYour,
    payCouponValYour,
    /* 售卖 */
    sellCouponNameYour,
    sellCouponValYour,
    /* 出价 */
    bidCouponNameFriend,
    bidCouponValFriend,
    lang,
  } = props

  return (
    <>
      <CommonHeader lang={lang} />
      <section className={styles.sharingOutside}>
        <div className={styles.benefits}>
          <div className={styles.group}>
            <DynamicColumns
              type="aHalf"
              columns={[
                {
                  isDiscount: false,
                  currencySign,
                  sum: registryCouponValYour1,
                  explain: registryCouponNameYour1,
                },
              ]}
              flow="before"
            />
            <SplitLine width={3} />
            <DynamicColumns
              type="aHalf"
              columns={[
                { currencySign, sum: registryCouponValYour2, explain: registryCouponNameYour2 },
              ]}
              flow="before"
            />
          </div>
        </div>
        <div className={styles.benefits}>
          <div className={styles.group}>
            <DynamicColumns
              type="aHalf"
              columns={[{ currencySign, sum: payCouponValYour, explain: payCouponNameYour }]}
              flow="before"
            />
            <SplitLine width={3} />
            <DynamicColumns
              type="aHalf"
              columns={[{ currencySign, sum: payCouponValFriend, explain: payCouponNameFriend }]}
              flow="before"
            />
          </div>
        </div>
        <CommonCoupon
          your={{
            type: 'percent',
            currencySign,
            sum: sellCouponValYour,
            explain: sellCouponNameYour,
          }}
          friend={{
            isDiscount: false,
            currencySign,
            sum: bidCouponValFriend,
            explain: bidCouponNameFriend,
          }}
        />
      </section>
    </>
  )
}

export default function Outside(props: IMachineConfig & IState) {
  const { lang, equity } = useContext(context)

  if (equity === 'seller') {
    return <Seller {...props} lang={lang} />
  }
  return <Transaction {...props} lang={lang} />
}
